import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { EVENT_TYPE } from '../../../../../ui-kitchen/src/components/Announcement/announcementTypes';

const DepthTracker = (props) => {
  const [fired, setFired] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.9,
  });

  const {
    Analytics, children, eventName, context, eventAsset, title, id,
  } = props;

  useEffect(() => {
    if (!fired && inView) {
      setFired(true);
      Analytics.event(eventName, {
        title,
        eventAsset,
        context,
      });
      Analytics.event(EVENT_TYPE.VIEW_ANNOUNCEMENT, {
        context,
        type: 'ad',
        title,
        id,
      });
    }
  }, [inView]);

  return (
    <>
      {React.Children.map(children, (child, index) => React.cloneElement(child, {
        ref, index,
      }))}
    </>
  );
};

DepthTracker.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  eventName: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  eventAsset: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string.isRequired,
};

DepthTracker.defaultProps = {
  eventAsset: '',
  title: '',
};

export default DepthTracker;
